import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, Renderer2 } from '@angular/core';

@Directive({
  selector: '[delegateLinks]'
})
export class DelegateLinksDirective implements AfterViewInit {
  @Output('delegateLinks') click = new EventEmitter<MouseEvent>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2) {
  }

  ngAfterViewInit(): void {
    this.el.nativeElement.querySelectorAll('a').forEach(
      (a: any) => this.renderer.listen(a, 'click', event => this.click.next(event)));
  }
}
